(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["breadcrumb"] && !Shopify.designMode) return;
  try {
    //VERIONES MOVILES FIX

  const mobileBreakpoint = 767;

  const checkBreadcrumbLength = () => {
    if (window.innerWidth <= mobileBreakpoint) {
      const breadcrumbContent = document.querySelector('.breadcrumb-content');
      const breadcrumbWidth = breadcrumbContent.offsetWidth;
      const breadcrumbElements = breadcrumbContent.children;

      let breadcrumbLength = 0;
      for (let i = 0; i < breadcrumbElements.length; i++) {
        breadcrumbLength += breadcrumbElements[i].offsetWidth;
      }

      if (breadcrumbLength > breadcrumbWidth) {
        for (let i = 1; i < breadcrumbElements.length - 2; i++) {
          breadcrumbElements[i].classList.add('breadcrumb-ellipsis');
        }
      } else {
        for (let i = 1; i < breadcrumbElements.length - 2; i++) {
          breadcrumbElements[i].classList.remove('breadcrumb-ellipsis');
        }
      }
    }
  };

  window.addEventListener('resize', checkBreadcrumbLength);
  window.addEventListener('DOMContentLoaded', checkBreadcrumbLength);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["filter-pills"] && !Shopify.designMode) return;
  try {
    class FilterPills extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback() {
    document.addEventListener('flu:collection:filtering-finished', this.handleFiltersUpdate.bind(this), {
      once: true
    });
  }

  disconnectedCallback() {
    this.removeEvents();
  }

  removeEvents() {
    document.removeEventListener('flu:collection:filtering-finished', this.handleFiltersUpdate);
  }

  handleFiltersUpdate(e) {
    const filterData = e.detail;
    this.scrollToActiveFilter();
  }

  scrollToActiveFilter() {
    const activeFilter = this.querySelector('.filter-pill[data-remove-filter]');
    if (activeFilter) {
      activeFilter.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }


}
if (!customElements.get('shflt-filter-pills')) {
  customElements.define('shflt-filter-pills', FilterPills);
}
  } catch(e) { console.error(e); }
})();

})();
